import getInternalLinkById from "./getInternalLinkById";
import getSitePages from "./getSitePages";
import { startCase } from "./stringUtilHelper";

const getSlugPartsTitle = (id, useFallbackLevel = false) => {
  const node = getInternalLinkById(id);
  const items = [];

  if (node) {
    const data = getSitePages();
    const slugParts = node.slug.split("/");
    slugParts.shift();
    let slug = "";

    if (slugParts.length > 0) {
      slugParts.forEach((slugPart) => {
        slug += `/${slugPart}`;
        const tmpNode = data.links.nodes.find((child) => child.slug === slug);

        items.push({ title: tmpNode ? tmpNode.title : startCase(slugPart) });
      });
    }
  }

  return items[(items.length < 2 || useFallbackLevel) ? 0 : 1].title;
};

export default getSlugPartsTitle;
